<div class="spinner-container">
    <span class="spinner" *ngIf="isProcessing"></span>
</div>
<div *ngIf="!isProcessing">
    <div class="mob-error" *ngIf="stopRegistration">{{this.passwordMessage}}</div>
    <!-- <div *ngIf="isSubmitted" >
        Congratulations on your sign-up! Your request is pending approval by the business owner. Expect an email and/or text notification upon approval. Once approved, you can sign in and get started. Thank you!
    </div> -->
    <div *ngIf="!stopRegistration">
        <!-- <mat-stepper orientation="vertical" [linear]="'true'" #stepper *ngIf="!isSubmitted" > -->
        <div *ngIf="!successDisplay">
            <mat-stepper class="mat-stepper" orientation="vertical" [linear]="true" #stepper *ngIf="!isSubmitted"
                (selectionChange)="onStepperSelectionChange($event)">
                <mat-step [stepControl]="locationFormGroup" *ngIf="!successDisplay">
                    <form [formGroup]="locationFormGroup">
                        <ng-template matStepLabel>Choose Your Business Location</ng-template>
                        <mat-form-field class="custom-input-lg form-field" appearance="outline">
                            <!-- <mat-label>Business Location</mat-label> -->
                            <input matInput placeholder="Business Location" formControlName="locationCtrl" required
                                [matAutocomplete]="auto" [errorStateMatcher]="matcher"
                                [readonly]="completeRegistration">
                            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onLocationSelected($event)">
                                <mat-option *ngFor="let location of filteredLocations | async"
                                    [value]="location.locationName">
                                    <img class="example-option-img" aria-hidden [src]="location.image" height="25">
                                    <span>{{location.locationName}},{{location.city}},{{location.state}},{{location.clientName}}</span>
                                </mat-option>
                            </mat-autocomplete>
                            <input type="hidden" formControlName="locationIdCtrl" />
                            <mat-error *ngIf="locfval['locationCtrl'].errors?.['required']">Business location is
                                required</mat-error>
                        </mat-form-field>
                        <div>
                            <button class="custom-button-md" *ngIf="!completeRegistration" mat-flat-button
                                color="primary" matStepperNext>Next</button>
                        </div>
                    </form>
                </mat-step>
                <mat-step [stepControl]="emailFormGroup" *ngIf="!successDisplay">
                    <form [formGroup]="emailFormGroup">
                        <ng-template matStepLabel>Tell Us Your Email Address</ng-template>
                        <mat-form-field class="custom-input-lg form-field" appearance="outline">
                            <!-- <mat-label>Email</mat-label> -->
                            <input matInput formControlName="emailCtrl" placeholder="Email" required
                                [errorStateMatcher]="matcher" [readonly]="completeRegistration"
                                (keyup)="emailEvent($event)">
                            <mat-error *ngIf="emailfval['emailCtrl'].errors?.['required']">Email is
                                required</mat-error>
                            <mat-error *ngIf="emailfval['emailCtrl'].errors?.['pattern']">Enter a
                                valid email address</mat-error>
                        </mat-form-field>
                        <p style="font-size: 12px; color:red;" *ngIf="emailError">*You are already a registered user.
                            Please contact
                            support@visitmaker.com</p>
                        <div class="button-space">
                            <button class="custom-button-md secondary-button" *ngIf="!completeRegistration"
                                mat-flat-button matStepperPrevious>Previous</button>
                            <button class="custom-button-md" *ngIf="!completeRegistration" mat-flat-button
                                color="primary" (click)="fetchUserDetails()" matStepperNext
                                [disabled]="emailError">Next</button>
                        </div>
                    </form>
                </mat-step>
                <mat-step [stepControl]="personalFormGroup" *ngIf="!successDisplay">
                    <div *ngIf="loadingUserDataByEmail">
                        Please wait ...
                    </div>
                    <ng-template matStepLabel>Let's Create Your Account</ng-template>
                    <form [formGroup]="personalFormGroup" *ngIf="!loadingUserDataByEmail">
                        <mat-form-field class="custom-input-lg form-field" appearance="outline">
                            <!-- <mat-label>First Name</mat-label> -->
                            <input matInput formControlName="fnameCtrl" placeholder="First Name" required
                                [errorStateMatcher]="matcher" [readonly]="completeRegistration">
                            <mat-error *ngIf="perfval['fnameCtrl'].errors?.['required']">First name is
                                required</mat-error>
                            <mat-error *ngIf="perfval['fnameCtrl'].errors?.['blockSpace']">First name should not contain
                                empty spaces</mat-error>
                        </mat-form-field>
                        <mat-form-field class="custom-input-lg form-field" appearance="outline">
                            <!-- <mat-label>Last Name</mat-label> -->
                            <input matInput formControlName="lnameCtrl" placeholder="Last Name" required
                                [errorStateMatcher]="matcher" [readonly]="completeRegistration">
                            <mat-error *ngIf="perfval['lnameCtrl'].errors?.['required']">Last name is
                                required</mat-error>
                            <mat-error *ngIf="perfval['lnameCtrl'].errors?.['blockSpace']">Last name should not contain
                                empty spaces</mat-error>
                        </mat-form-field>
                        <mat-form-field class="custom-input-lg form-field" appearance="outline">
                            <ngx-mat-intl-tel-input style="height: 0px;" formControlName="mobileCtrl" (countryChanged)="onCountryChange($event)"
                                [enablePlaceholder]="true" [errorStateMatcher]="matcher" [enableSearch]="true"
                                name="phoneInput" inputPlaceholder="Phone number" [preferredCountries]="['us']"
                                #phoneInput [readonly]="completeRegistration"></ngx-mat-intl-tel-input>
                            <mat-error *ngIf="perfval['mobileCtrl'].errors?.['required']">Phone number is
                                required</mat-error>
                            <mat-error *ngIf="perfval['mobileCtrl'].errors?.['validatePhoneNumber']">Invalid Phone
                                number</mat-error>
                        </mat-form-field>
                        <mat-form-field class="custom-input-lg form-field" appearance="outline"
                            [hidden]="hidePasswords">
                            <!-- <mat-label>Password</mat-label> -->
                            <input [type]="showNewPassword ? 'text' : 'password'" matInput
                                formControlName="passwordCtrl" placeholder="Password" required
                                [errorStateMatcher]="matcher" [readonly]="completeRegistration">
                            <mat-icon svgIcon="lock" class="icon-space icon-color icon" matPrefix></mat-icon>
                            <button type="button" *ngIf="!completeRegistration" mat-icon-button matSuffix
                                (click)="passwordClick()">
                                <mat-icon [svgIcon]="showNewPassword ? 'show' : 'hide'" class="icon-color"></mat-icon>
                            </button>
                            <mat-error *ngIf="perfval['passwordCtrl'].errors?.['required']">Password is
                                required</mat-error>
                            <mat-error class="validate-message" *ngIf="perfval['passwordCtrl'].errors?.['pattern']">8 or
                                more characters with a mix of letters, numbers & symbols*</mat-error>
                        </mat-form-field>
                        <mat-form-field class="custom-input-lg form-field" appearance="outline"
                            [hidden]="hidePasswords">
                            <!-- <mat-hint>Password and Confirm Password should be the same</mat-hint> -->
                            <!-- <mat-label>Confirm Password</mat-label> -->
                            <input [type]="showConfirmPassword ? 'text' : 'password'" matInput
                                formControlName="confirmPassCtrl" placeholder="Confirm Password" required
                                [errorStateMatcher]="matcher" [readonly]="completeRegistration">
                            <mat-icon svgIcon="lock" class="icon-space icon-color icon" matPrefix></mat-icon>
                            <button type="button" *ngIf="!completeRegistration" mat-icon-button matSuffix
                                (click)="confirmClick()">
                                <mat-icon [svgIcon]="showConfirmPassword ? 'show' : 'hide'"
                                    class="icon-color"></mat-icon>
                            </button>
                            <mat-error *ngIf="perfval['confirmPassCtrl'].errors?.['required']">Confirm password is
                                required</mat-error>
                            <mat-error class="validate-message"
                                *ngIf="perfval['confirmPassCtrl'].errors?.['mustMatch']">Password and Confirm password
                                didn't
                                match.*</mat-error>
                        </mat-form-field>
                        <div class="pass-msg">{{passwordMessage}}</div>
                        <div class="button-space">
                            <button class="custom-button-md secondary-button" *ngIf="!completeRegistration"
                                mat-flat-button matStepperPrevious>Previous</button>
                            <button class="custom-button-md" *ngIf="!completeRegistration" mat-flat-button
                                color="primary" matStepperNext>Next</button>
                        </div>
                    </form>
                </mat-step>
                <mat-step [stepControl]="loftInfoFormGroup" *ngIf="!successDisplay">
                    <form [formGroup]="loftInfoFormGroup">
                        <ng-template matStepLabel>Tell Us About Your Business</ng-template>
                        <mat-form-field class="custom-input-lg form-field" appearance="outline">
                            <!-- <mat-label>Suite Number</mat-label> -->
                            <input matInput placeholder="Suite Number" formControlName="loftNoCtrl" required
                                [errorStateMatcher]="matcher" [readonly]="completeRegistration">
                            <mat-error *ngIf="loftfval['loftNoCtrl'].errors?.['required']">Suite number is
                                required</mat-error>
                            <mat-error *ngIf="loftfval['loftNoCtrl'].errors?.['blockSpace']">Suite number should not
                                contain
                                empty spaces</mat-error>
                        </mat-form-field>
                        <mat-form-field class="custom-input-lg form-field" appearance="outline">
                            <!-- <mat-label>Suite Name</mat-label> -->
                            <input matInput placeholder="Suite Name" formControlName="loftNameCtrl" required
                                [errorStateMatcher]="matcher" [readonly]="completeRegistration">
                            <mat-error *ngIf="loftfval['loftNameCtrl'].errors?.['required']">Suite name is
                                required</mat-error>
                            <mat-error *ngIf="loftfval['loftNameCtrl'].errors?.['blockSpace']">Suite name should not
                                contain
                                empty spaces</mat-error>
                        </mat-form-field>
                        <div class="pass-msg">{{passwordMessage}}</div>
                        <div class="button-space">
                            <button class="custom-button-md secondary-button" *ngIf="!completeRegistration"
                                mat-flat-button matStepperPrevious>Previous</button>
                            <button class="custom-button-md" *ngIf="!completeRegistration" mat-flat-button
                                color="primary" matStepperNext>Preview</button>
                        </div>
                    </form>
                </mat-step>
                <mat-step [stepControl]="previewFormGroup" *ngIf="!successDisplay">
                    <ng-template matStepLabel>Preview</ng-template>
                    <form [formGroup]="previewFormGroup">
                        <div style="pointer-events: none;">
                            <mat-form-field class="custom-input-lg form-field" appearance="outline">
                                <mat-label>Location Name</mat-label>
                                <input matInput type="text" formControlName="locationCtrl" placeholder="Location Name"
                                    readonly>
                            </mat-form-field>

                            <mat-form-field class="custom-input-lg form-field" appearance="outline">
                                <mat-label>First Name</mat-label>
                                <input matInput type="text" formControlName="fnameCtrl" placeholder="First Name"
                                    readonly>
                            </mat-form-field>

                            <mat-form-field class="custom-input-lg form-field" appearance="outline">
                                <mat-label>Last Name</mat-label>
                                <input matInput type="text" formControlName="lnameCtrl" placeholder="Last Name"
                                    readonly>
                            </mat-form-field>

                            <mat-form-field class="custom-input-lg form-field" appearance="outline">
                                <mat-label>Email</mat-label>
                                <input matInput type="text" formControlName="emailCtrl" placeholder="Email" readonly>
                            </mat-form-field>

                            <mat-form-field class="custom-input-lg form-field" appearance="outline">
                                <mat-label>Phone Number</mat-label>
                                <input matInput type="text" formControlName="mobileCtrl" placeholder="Mobile Number"
                                    readonly>
                            </mat-form-field>

                            <mat-form-field class="custom-input-lg form-field" appearance="outline">
                                <mat-label>Password</mat-label>
                                <input matInput type="text" formControlName="passwordCtrl" placeholder="Password"
                                    readonly>
                            </mat-form-field>

                            <mat-form-field class="custom-input-lg form-field" appearance="outline">
                                <mat-label>Suite Number</mat-label>
                                <input matInput type="text" formControlName="loftNoCtrl" placeholder="Suite Number"
                                    readonly>
                            </mat-form-field>

                            <mat-form-field class="custom-input-lg form-field" appearance="outline">
                                <mat-label>Suite Name</mat-label>
                                <input matInput type="text" formControlName="loftNameCtrl" placeholder="Suite Name"
                                    readonly>
                            </mat-form-field>
                        </div>


                        <div *ngIf="!successDisplay">
                            <div *ngIf="!loadingUserDataByEmail" class="text-center p-2"
                                style="display: flex; align-items: center; justify-content: center;">
                                <input [checked]="isLogOn" (change)="onTermsChoosen($event)" type="checkbox">
                                <small style="padding-left: 5px;">I agree <a class=" userLogin" (click)="terms()">Terms
                                        of
                                        Services</a> & <a class=" userLogin" (click)="privacy()">Privacy
                                        Policy</a></small>
                            </div>
                            <div class="button-submit" *ngIf="!loadingUserDataByEmail">
                                <button class="custom-button-md secondary-button" style="margin-right: 5px;"
                                    (click)="editForm()" mat-flat-button>Edit</button>
                                <button class="custom-button-md" *ngIf="!completeRegistration" [disabled]="!enableSave"
                                    mat-flat-button color="primary" matStepperNext
                                    (click)="submitOnboardingForm()">Submit</button>
                            </div>
                        </div>
                    </form>
                    <div *ngIf="loadingUserDataByEmail" style="text-align: center; padding: 15px 0;">
                        Please wait ...
                    </div>

                    <div class="center-container" *ngIf="successDisplay">
                        <div class="center-content" *ngIf="!loadingUserDataByEmail">
                            <img src="assets\images\green-success.svg" width="200" height="200" alt="">
                            <p>Congratulations on your sign-up! Your request is pending for approval by the business
                                owner. Expect an email and/or text notification upon approval. Once approved, you can
                                sign in and get started. Thank you!</p>
                            <div class="button-submit">
                                <button class="custom-button-md" mat-flat-button color="primary"
                                    (click)="stepper.reset(); navigateUrl()">Ok</button>
                            </div>
                        </div>
                    </div>
                </mat-step>
            </mat-stepper>
        </div>
        <div class="success-screen-wrapper" *ngIf="successDisplay">
            <div class="center-container">
                <div class="center-content" *ngIf="!loadingUserDataByEmail">
                    <img src="assets/images/green-success.svg" width="180" height="180" alt="Success">
                    <p>Congratulations on your sign-up! Your request is pending for approval by the business owner.
                        Expect an email and/or text notification upon approval. Once approved, you can sign in and get
                        started. Thank you!</p>
                    <div class="button-submit">
                        <button class="custom-button-md" mat-flat-button color="primary"
                            (click)="navigateUrl()">Ok</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- </div> -->
    </div>
</div>